import React, { useEffect } from 'react';
import { LandingComponent, SubLandingComponent } from 'app/types';
import Text from 'common/components/Text/Text';

import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { useMediaQuery } from 'react-responsive';
import styles from '../LandingForm.module.scss';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const TestimonialPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  useEffect(() => {
    const carouselInterval = setInterval(() => {
      const nextButton = document.querySelector('.carousel-control-next') as HTMLButtonElement;
      if (nextButton) {
        nextButton.click();
      }
    }, 10000);

    return () => clearInterval(carouselInterval);
  }, []);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: landing_cmp.size !== 'sm' && landing_cmp.size !== 'md' ? landing_cmp.size : 'auto',
        padding: landing_cmp.size === 'sm' ? '0 12rem' : '0 4vw',
        margin: landing_cmp.gap,
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundSize: landing_cmp.background_size,
        backgroundImage: `url(${landing_cmp.background_image})`,
      }}
      className={landing_cmp.class_name}
      key={landing_cmp.id}
    >
      {(landing_cmp.config.title || landing_cmp.config.section_title) && (
        <div
          className="headerSection"
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
          {landing_cmp.config.section_title && (
            <div className={`${styles.sectionTitle} text-center d-flex flex-column`}>
              {landing_cmp.config.section_title}
              <div
                style={{ width: '87px', height: '8px', background: '#E8F3FE', alignSelf: 'center' }}
              ></div>
            </div>
          )}
          {landing_cmp.config.title && (
            <div
              style={{
                fontSize: '40px',
                color: '#193676',
                fontWeight: '700',
                textAlign: 'center',
                marginBottom: '44px',
              }}
            >
              {landing_cmp.config.title}
            </div>
          )}
        </div>
      )}
      {landing_cmp.config.description && (
        <Text
          size={16}
          weight={400}
          inlineStyle={{ textAlign: 'center', maxWidth: '65%', marginBottom: '56px' }}
        >
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {landing_cmp.config.description}
          </ReactMarkdown>
        </Text>
      )}
      {landing_cmp.sub_landing_components && landing_cmp.sub_landing_components.length > 0 && (
        <div
          id={`carouselTestimonials_${landing_cmp.id}`}
          className="carousel slide"
          data-ride="carousel"
          data-bs-interval={1000}
          style={{ width: '80%' }}
        >
          <ol className="carousel-indicators">
            {landing_cmp.sub_landing_components.map(
              (testimonial: SubLandingComponent, index: number) => (
                <button
                  key={testimonial.id}
                  type="button"
                  data-bs-target={`#carouselTestimonials_${landing_cmp.id}`}
                  data-bs-slide-to={`${index}`}
                  className={`${index === 0 ? 'active' : ''}`}
                  aria-current="true"
                  aria-label={`Slide ${index}`}
                  style={{ backgroundColor: '#727D9B' }}
                ></button>
              )
            )}
          </ol>
          <div className="carousel-inner br-26">
            {landing_cmp.sub_landing_components.map(
              (testimonial: SubLandingComponent, index: number) => (
                <div
                  key={testimonial.id}
                  className={`carousel-item ${index === 0 ? 'active' : ''}`}
                >
                  <div
                    className={`${styles.testimonialCardContainer} row px-md-5 px-3 p-xl-5 py-4 gap-xl-0 gap-3`}
                  >
                    <div className={`${styles.testimonialInfo} col-12 col-xl-8 order-xl-1 order-5`}>
                      <Text
                        size={20}
                        weight={500}
                        inlineStyle={{ color: '19234F', marginBottom: '' }}
                      >
                        {testimonial.config.testimonial_title}
                      </Text>
                      <Text
                        size={16}
                        weight={400}
                        inlineStyle={{
                          color: '#19234F',
                        }}
                      >
                        <ReactMarkdown>{testimonial.config.description}</ReactMarkdown>
                      </Text>
                    </div>

                    {testimonial.image_file && typeof testimonial.image_file === 'string' ? (
                      <div className="col-12 col-xl-4 order-xl-5 order-1 p-0 d-flex justify-content-center">
                        <img
                          src={testimonial.image_file}
                          width="242px"
                          height={'242px'}
                          style={{ borderRadius: '50%' }}
                        />
                      </div>
                    ) : (
                      <div
                        className="col col-sm-4 order-sm-5 order-1 d-flex justify-content-center align-items-center"
                        style={{ fontSize: '200px' }}
                      >
                        <i className="bi bi-person-circle"></i>
                      </div>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
          <button
            className={`carousel-control-prev`}
            type="button"
            data-bs-target={`carouselTestimonials_${landing_cmp.id}`}
            data-bs-slide="prev"
          ></button>
          <button
            className={`carousel-control-next`}
            type="button"
            data-bs-target={`carouselTestimonials_${landing_cmp.id}`}
            data-bs-slide="next"
          ></button>
        </div>
      )}
    </div>
  );
};

export default TestimonialPreview;
